import {Component, Input, OnDestroy, OnInit, EventEmitter, Output} from '@angular/core';
import {PaymentsService} from 'src/app/services/payments.service';
import {ToastrService} from 'ngx-toastr';
import {PaymentGroupModel, PaymentMethod, PropertyPaymentMethodHinge} from 'src/app/models/PaymentModels';
import {PropertyService} from 'src/app/property-module/services/property.service';
import {ClientLocationDropDownValue} from 'src/app/clients-module/models/clientLocation';
import {AddPaymentGroupModalComponent} from '../add-payment-group-modal/add-payment-group-modal.component';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assign-payment-method',
  templateUrl: './assign-payment-method.component.html',
  styleUrls: ['./assign-payment-method.component.less']
})
export class AssignPaymentMethodComponent implements OnInit, OnDestroy {
  @Input() public payment: PaymentMethod;
  @Input() public clientId: number;
  @Output() public paymentAssignComplete : EventEmitter<boolean> = new EventEmitter()
  public paymentAssignment: PropertyPaymentMethodHinge = new PropertyPaymentMethodHinge();
  public assignTo = '';
  public availableGroups: PaymentGroupModel[] = [];
  private $destroy = new Subject();
  private _locations: ClientLocationDropDownValue[] = [];
  public get locations(): ClientLocationDropDownValue[] { return this._locations.filter(r => r.clientId == this.clientId);  }
  public get groups(): PaymentGroupModel[] { return this.availableGroups; }
  public get model(): PropertyPaymentMethodHinge { return this.paymentAssignment; }

  constructor(private modalService : NgbModal,private payments: PaymentsService, private toast: ToastrService, private propertyService: PropertyService, private readonly paymentService: PaymentsService) { }

  public ngOnInit() {
     this.paymentService.loadPaymentGroups(this.clientId).subscribe((r: PaymentGroupModel[]) => {
      this.availableGroups = r;
    });

    this.propertyService.FetchAllPropertiesDropDownDataForUser().subscribe((scc: ClientLocationDropDownValue[]) => {
      scc.forEach(ddVal => {
        this._locations.push(ddVal);
      });
    }, (err: any) => {
      this.toast.error('There was an error pulling locations for your user Id.', 'Error fetching locations', {
        closeButton: true,
        disableTimeOut: true
      });
    });

    this.paymentService.$lastAddedPaymentGroup.pipe(takeUntil(this.$destroy)).subscribe((r: PaymentGroupModel) => {
      // The latest group is passed in, so set that as the new default to the dropdown
      this.model.groupId = r.id;
    });
  }

  public ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  public save(): boolean {
    if (this.assignTo === '') {
      return false;
    }
    if (this.assignTo === 'all') {
      this.model.propertyId = 0;
    }
    if (this.assignTo === 'group') {
      // this.model.groupId;
    }

    this.model.paymentMethodId = this.payment.id;
    this.model.clientId = this.clientId;
    this.payments.AssignPaymentMethod(this.model).subscribe(r => {
        this.toast.success('Payment method assigned successfully.', '');
        this.paymentAssignComplete.next(true);
        return true;
      },
      err => {
        this.toast.error('Error assigning payment method!', '', {closeButton: true, disableTimeOut: true})
        this.paymentAssignComplete.next(false);
      });

  }

  public addPaymentGroupMethod(): void {
    const modalRef = this.modalService.open(AddPaymentGroupModalComponent, {centered: true, size: 'lg'});
    modalRef.componentInstance.name = 'AddPaymentGroupModalComponent';
    modalRef.componentInstance.clientId = this.clientId;

    // if any action is taken in the add pmt modal, we should refetch the pmt groups to reflect that
    modalRef.result.finally(() => {
      this.paymentService.loadPaymentGroups(this.clientId).subscribe((r: PaymentGroupModel[]) => {
        this.availableGroups = r;
      });
    });
  }
}
